module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_8.c91adf36ad2e724aea892617ef8a1234.png";